import * as React from "react";
import ChannelCustomizerSection from "./ChannelCustomizerSection";
import styled from "styled-components";
import { ChannelCustomization, ProperyChangeType } from "./customizationHelpers";
import ChannelCustomizerLatency from "./ChannelCustomizerLatency";
import ChannelHlsSettings from "./ChannelHlsSettings";

interface Props {
    customization: ChannelCustomization;
    onCustomizationChange: (type: ProperyChangeType, key: string, value: string | boolean | number | object) => void;
}

const Wrapper = styled.div``;

function ChannelCustomizer({ customization, onCustomizationChange }: Props) {
    return (
        <Wrapper>
            <ChannelCustomizerSection
                customizations={
                    <>
                        <ChannelCustomizerLatency
                            currentTargetLatency={customization.targetLatency}
                            onCustomizationChange={(type: ProperyChangeType, key: string, value: number) =>
                                onCustomizationChange(type, key, value)
                            }
                        />
                        <ChannelHlsSettings
                            enabled={customization.hls.enabled}
                            onChange={() =>
                                onCustomizationChange("main", "hls", { enabled: !customization.hls.enabled })
                            }
                        />
                    </>
                }
            />
        </Wrapper>
    );
}

export default ChannelCustomizer;
